export default "__VITE_ASSET__CKL9nVTb__"